var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgesapphire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 82,
    viewBox: "0 0 75 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6089_19734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0637 2.87095C36.5005 1.76756 38.4995 1.76756 39.9363 2.87095L49.8811 10.508C50.1591 10.7216 50.4641 10.8976 50.7881 11.0317L62.3744 15.8256C64.0483 16.5182 65.0478 18.2494 64.8107 20.0454L63.1691 32.4763C63.1232 32.8239 63.1232 33.1761 63.1691 33.5237L64.8107 45.9546C65.0478 47.7506 64.0483 49.4818 62.3744 50.1744L50.7881 54.9683C50.4641 55.1024 50.1591 55.2784 49.8811 55.492L39.9363 63.1291C38.4995 64.2324 36.5005 64.2324 35.0637 63.1291L25.1189 55.492C24.8409 55.2784 24.5359 55.1024 24.2119 54.9683L12.6256 50.1744C10.9517 49.4818 9.95217 47.7506 10.1893 45.9546L11.8309 33.5237C11.8768 33.1761 11.8768 32.8239 11.8309 32.4763L10.1893 20.0454C9.95217 18.2494 10.9517 16.5182 12.6256 15.8256L24.2119 11.0317C24.5359 10.8976 24.8408 10.7216 25.1189 10.508L35.0637 2.87095Z",
    fill: "url(#paint0_linear_6089_19734)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6089_19734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5 58C51.3072 58 62.5001 46.8071 62.5001 33C62.5001 19.1929 51.3072 8 37.5 8C23.6929 8 12.5 19.1929 12.5 33C12.5 46.8071 23.6929 58 37.5 58Z",
    fill: "url(#paint1_linear_6089_19734)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M37.5 55C49.6503 55 59.5001 45.1503 59.5001 33C59.5001 20.8497 49.6503 11 37.5 11C25.3498 11 15.5 20.8497 15.5 33C15.5 45.1503 25.3498 55 37.5 55Z",
    fill: "url(#paint2_radial_6089_19734)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.5 32.9261C58.5 33.7868 58.4508 34.6474 58.3523 35.4835C58.2538 36.4179 58.0569 37.3523 57.8353 38.2376C57.7368 38.631 57.6383 38.9999 57.5152 39.3933C57.2937 40.0818 57.0475 40.7704 56.7521 41.4343C56.112 42.8851 55.3242 44.2375 54.3886 45.4916C53.6008 46.549 52.7146 47.5326 51.7298 48.4424C48.0124 51.885 43.0393 53.9752 37.574 53.9998C32.1086 54.0244 27.1109 51.9588 23.3689 48.5408C22.4087 47.6556 21.5224 46.6966 20.7346 45.6638C19.2575 43.7212 18.125 41.5081 17.4111 39.1474C17.0664 38.0409 16.8202 36.8851 16.6725 35.7048C16.5741 34.8442 16.5002 33.9835 16.5002 33.1229C16.451 21.4672 25.8061 12.0492 37.4262 12C49.0217 11.9755 58.4508 21.3197 58.5 32.9261Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 54C49.098 54 58.5 44.598 58.5 33C58.5 21.402 49.098 12 37.5 12C25.902 12 16.5 21.402 16.5 33C16.5 44.598 25.902 54 37.5 54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 54C49.098 54 58.5 44.598 58.5 33C58.5 21.402 49.098 12 37.5 12C25.902 12 16.5 21.402 16.5 33C16.5 44.598 25.902 54 37.5 54Z",
    fill: "url(#paint3_linear_6089_19734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3906 37V25.7969H39.5234C41.3359 25.7969 42.2422 26.7057 42.2422 28.5234V30.1172C42.2422 31.9349 41.3359 32.8438 39.5234 32.8438H34.9922V37H33.3906ZM34.9922 31.2422H39.4375C39.8646 31.2422 40.1719 31.1484 40.3594 30.9609C40.5469 30.7734 40.6406 30.4661 40.6406 30.0391V28.6016C40.6406 28.1745 40.5469 27.8672 40.3594 27.6797C40.1719 27.4922 39.8646 27.3984 39.4375 27.3984H34.9922V31.2422Z",
    fill: "url(#paint4_linear_6089_19734)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6089_19734",
    x: -4.5,
    y: -1,
    width: 84,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 0.0196078 0 0 0 0 0.2 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6089_19734"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6089_19734",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6089_19734",
    x: 6.5,
    y: 5,
    width: 62,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 0.0196078 0 0 0 0 0.2 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6089_19734"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6089_19734",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6089_19734",
    x1: 5.46529,
    y1: 32.9895,
    x2: 69.5138,
    y2: 32.9895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F52BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3123,
    stopColor: "#419CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7592,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F52BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6089_19734",
    x1: 12.4729,
    y1: 32.9918,
    x2: 62.5108,
    y2: 32.9918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F52BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3123,
    stopColor: "#419CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7592,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F52BA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_6089_19734",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.489 32.9889) scale(21.9893 21.9893)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#571600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6089_19734",
    x1: 37.5,
    y1: 12,
    x2: 37.5,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6089_19734",
    x1: 31.4935,
    y1: 32.9974,
    x2: 43.5026,
    y2: 32.9974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F52BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3123,
    stopColor: "#419CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7592,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F52BA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgesapphire);
export default __webpack_public_path__ + "static/media/badge sapphire.32e4b48ab30e4509815e0883dab7868b.svg";
export { ForwardRef as ReactComponent };